import { createHttpLink } from '@apollo/client';

/**
 * @name httpLink
 * @description GraphQl http link
 */

export const httpLink = (uri) =>
  createHttpLink({
    uri: uri,
  });
